export default {
  management: [
    {
      title: "Dynobase",
      image: "dynobasetool",
      link: "/",
    },
    {
      title: "NoSQL Workbench",
      image: "nosql-workbench",
      link: "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/workbench.html",
    },
  ],
  iac: [
    {
      title: "Serverless Framework",
      image: "serverless-framework",
      link: "https://www.serverless.com/",
    },
    {
      title: "Terraform",
      image: "terraform",
      link: "https://developer.hashicorp.com/terraform",
    },
    {
      title: "AWS CloudFormation",
      image: "aws-cloudformation",
      link: "https://aws.amazon.com/cloudformation/",
    },
    {
      title: "AWS Amplify",
      image: "aws-amplify",
      link: "https://aws.amazon.com/amplify/",
    },
    {
      title: "Pulumi",
      image: "pulumi",
      link: "https://www.pulumi.com/",
    },
    {
      title: "AWS CDK",
      image: "aws-cdk",
      link: "https://aws.amazon.com/cdk/",
    },
    {
      title: "AWS SAM",
      image: "aws-sam",
      link: "https://aws.amazon.com/serverless/sam/",
    },
  ],
  utility: [
    {
      title: "DynamoDB Pricing Calculator",
      image: "dynamodb-pricing-calculator",
      link: "/dynamodb-pricing-calculator/",
    },
    {
      title: "DynamoDB DAX pricing calculator",
      link: "/dynamodb-dax-pricing/",
    },
    {
      title: "DynamoDB capacity and item size calculator",
      image: "dynamodb-item-size-calculator",
      link: "/dynamodb-capacity-and-item-size-calculator/",
    },
    {
      title: "DynamoDB Query Builder",
      image: "dynamodb-visual-query-builder",
      link: "/dynamodb-query-builder/",
    },
    {
      title: "DynamoDB UUID Generator",
      link: "/dynamodb-uuid-generator/",
    },
    {
      title: "DynamoDB JSON converter",
      link: "/dynamodb-json-converter-tool/",
    },
    {
      title: "DynamoDB table schema design tool",
      link: "/dynamodb-table-schema-design-tool/",
    },
  ],
  local: [
    {
      title: "LocalStack DynamoDB",
      link: "https://docs.localstack.cloud/aws/services/dynamodb/",
      description: "Develop and test DynamoDB alongside other emulated AWS services. Check LocalStack's current access requirements.",
    },
    {
      title: "Dynalite",
      link: "https://github.com/architect/dynalite",
      description: "An implementation of Amazon's DynamoDB built on LevelDB.",
    },
    {
      title: "serverless-dynamodb",
      link: "https://github.com/raisenational/serverless-dynamodb",
      description: "Serverless Framework plugin for DynamoDB Local; continuation of serverless-dynamodb-local.",
    },
    {
      title: "DynamoDB Local (official distribution)",
      link: "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DynamoDBLocal.DownloadingAndRunning.html",
      description: "Run the AWS distribution locally with Docker or a Java runtime.",
    },
    {
      title: "jest-dynamodb",
      link: "https://github.com/shelfio/jest-dynamodb",
      description: "Jest preset for DynamoDB local server",
    },
  ],
  backup: [
    {
      title: "dynamodump",
      link: "https://github.com/bchew/dynamodump",
      description: "Backup and restore scripts using the AWS SDK for Python (boto3).",
    },
    {
      title: "DynamoDB Continuous Backups (archived)",
      link: "https://github.com/awslabs/dynamodb-continuous-backup",
      description: "Archived backup automation project. Prefer managed backups or PITR for new recovery plans.",
    },
    {
      title: "DynamoDB Backup to S3",
      link: "https://github.com/markitx/dynamo-backup-to-s3",
      description: "Community scripts for streaming DynamoDB backups to S3; review restore behavior before relying on them.",
    },
    {
      title: "Serverless DynamoDB Backups",
      link: "https://github.com/alexdebrie/serverless-dynamodb-backups",
      description: "A plugin for scheduling DynamoDB backups with Serverless Framework.",
    },
    {
      title: "dynamodb-stream-elasticsearch",
      link: "https://github.com/matrus2/dynamodb-stream-elasticsearch",
      description: "A Lambda blueprint that copies stream changes to Elasticsearch; a search integration, not a restorable backup.",
    },
    {
      title: "copy-dynamodb-table (archived)",
      link: "https://github.com/enGMzizo/copy-dynamodb-table",
      description: "Archived utility for copying table data. Verify destination keys, capacity and settings separately.",
    },
  ],
  libraries: {
    javascript: [
      {
        title: "Dynamoose",
        link: "https://github.com/dynamoose/dynamoose",
        description: "A DynamoDB modeling library inspired by Mongoose.",
      },
      {
        title: "serverless-dynamodb-local (legacy)",
        link: "https://github.com/99x/serverless-dynamodb-local",
        description: "Older local-development plugin; use serverless-dynamodb for its maintained continuation.",
      },
      {
        title: "Dynogels",
        link: "https://github.com/clarkie/dynogels",
        description: "A Node.js data mapper with streaming and parallel-scan helpers. Check SDK compatibility before adoption.",
      },
      {
        title: "Dynamite",
        link: "https://github.com/Medium/dynamite",
        description: "A promise-based DynamoDB client. Check SDK compatibility before adopting it in a new application.",
      },
      {
        title: "Dynasty",
        link: "https://github.com/victorquinn/dynasty",
        description: "A promise-based DynamoDB API written in CoffeeScript.",
      },
      {
        title: "AWS Pilot",
        link: "https://github.com/awspilot/dynamodb-oop",
        description: "An object-oriented DynamoDB wrapper for JavaScript.",
      },
      {
        title: "DynamoDB Streams Processor",
        link: "https://github.com/jeremydaly/dynamodb-streams-processor",
        description: "Simple tool to help process DynamoDB Streams.",
      },
      {
        title: "flynamo",
        link: "https://github.com/flybondi/flynamo",
        description: "DynamoDB functional wrapper.",
      },
      {
        title: "ElectroDB",
        link: "https://github.com/tywalch/electrodb",
        description: "Model multiple entities and access patterns for single-table designs with JavaScript and TypeScript.",
      },
      {
        title: "DynamoDB OneTable (archived)",
        link: "https://github.com/sensedeep/dynamodb-onetable",
        description: "Archived Node.js access library for single-table designs; review maintenance requirements before adoption.",
      },
    ],
    typescript: [
      {
        title: "DynamoDB Toolbox",
        link: "https://www.dynamodbtoolbox.com/",
        description: "A type-safe DynamoDB query builder with schemas and entities for TypeScript.",
      },
      {
        title: "DynamoDB DataMapper for JavaScript (archived)",
        link: "https://github.com/awslabs/dynamodb-data-mapper-js",
        description: "Archived schema-based mapper built around the older JavaScript SDK.",
      },
      {
        title: "DynamoTypes",
        link: "https://github.com/balmbees/dynamo-types",
        description: "A TypeScript DynamoDB object mapper.",
      },
      {
        title: "TypeDynamo",
        link: "https://github.com/lucasmafra/type-dynamo",
        description: "A DynamoDB object mapper for TypeScript and Node.js.",
      },
      {
        title: "Dynoexpr",
        link: "https://github.com/ruicsh/dynoexpr",
        description: "Build DynamoDB expressions and attribute placeholders from JavaScript objects.",
      },
      {
        title: "dynamodb-pipeline",
        link: "https://github.com/RossWilliams/dynamo-pipeline",
        description: "Alternative API for DynamoDB DocumentClient",
      },
      {
        title: "dynamodb-geo.js",
        link: "https://github.com/robhogan/dynamodb-geo.js",
        description: "A TypeScript port of the DynamoDB geospatial indexing library.",
      },
    ],
    python: [
      {
        title: "PynamoDB",
        link: "https://github.com/pynamodb/PynamoDB",
        description: "A Python object-modeling interface for DynamoDB; current releases target Python 3.",
      },
      {
        title: "Flywheel (archived)",
        link: "https://github.com/stevearc/flywheel",
        description: "Archived Python object mapper for DynamoDB.",
      },
      {
        title: "DynamORM (archived)",
        link: "https://github.com/NerdWalletOSS/dynamorm",
        description: "Archived Python object and relation mapping library for DynamoDB.",
      },
      {
        title: "django-dynamodb-sessions (archived)",
        link: "https://github.com/gtaylor/django-dynamodb-sessions",
        description: "Archived Django session backend for DynamoDB.",
      },
      {
        title: "dynamic-dynamodb",
        link: "https://github.com/sebdah/dynamic-dynamodb",
        description: "A custom provisioned-capacity scaling tool; compare with DynamoDB Auto Scaling for new deployments.",
      },
      {
        title: "flask-dynamo",
        link: "https://github.com/rdegges/flask-dynamo",
        description: "DynamoDB integration for Flask",
      },
      {
        title: "dynamodb-json",
        link: "https://github.com/Alonreznik/dynamodb-json",
        description: "Convert DynamoDB JSON to and from Python objects.",
      },
    ],
    golang: [
      {
        title: "Dynamo",
        link: "https://github.com/guregu/dynamo",
        description: "A Go DynamoDB library using the AWS SDK for Go v2.",
      },
      {
        title: "Dynamolock",
        link: "https://github.com/cirello-io/dynamolock",
        description: "DynamoDB Lock Client for Go",
      },
    ],
    ruby: [
      {
        title: "Dynamoid",
        link: "https://github.com/Dynamoid/dynamoid",
        description: "Ruby ORM for Amazon's DynamoDB.",
      },
      {
        title: "fake_dynamo",
        link: "https://github.com/ananthakumaran/fake_dynamo",
        description: "An in-memory DynamoDB emulator written in Ruby.",
      },
    ],
    php: [
      {
        title: "laravel-dynamodb",
        link: "https://github.com/baopham/laravel-dynamodb",
        description: "Eloquent syntax for DynamoDB in PHP",
      },
    ],
    dotnet: [
      {
        title: "Dynamo.ORM",
        link: "https://github.com/marcodafonseca/Dynamo.ORM",
        description: "An asynchronous DynamoDB object mapper for .NET Standard; check compatibility with your AWS SDK version.",
      },
    ],
  },
}
